import React, { useEffect, useState, forwardRef } from 'react';
import { LoadSession } from '../isdlData/sessionData';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';

const NewSessionTaskModal  = forwardRef(({ConflictType, TaskId, ConflictData, NewSessionTaskModalResult}, ref) => {

    const [loadedSessionData, setLoadedSessionData] = useState(null);

    useEffect(() => {
        const loadSessionInfo = async () => {
            setLoadedSessionData(await LoadSession(ConflictData, true));
        };

        if(ConflictType === "NewUser"){
            setLoadedSessionData(null);
            loadSessionInfo();
        }

        return () => {
            setLoadedSessionData(null);
        };
    },[ConflictData]);

    return(
<div className='modal-container' style={{height:"300px", maxWidth:"500px"}}>
    <button className='modal-close-button' onClick={() => NewSessionTaskModalResult(false)}><Cross2Icon width='30px' height='30px'/></button>
    <div className='modal-header'>Session Conflict</div>
    <div className='modal-content'>
        {ConflictType === "NewUser" && (
            <>
                <h4>There already is a session with this task id ({TaskId}). Do you want to add the golfer to this task?</h4>
                {loadedSessionData != null && (
                    <strong>{loadedSessionData.Description}</strong>
                )}
                {loadedSessionData == null && (
                    <i>Loading...</i>
                )}
            </>
        )}

        {ConflictType === "SameUser" && (
            <>
                <h4>There already is a user in a session with this task id ({TaskId}). Do you want to load that session?</h4>
                <strong>{ConflictData.Golfer.FullName}</strong>
            </>
        )}
    </div>

    <div className="modal-footer" >
        <button className="button" style={{width:'100px'}} onClick={() => NewSessionTaskModalResult(true)}>Yes</button>
    </div>
</div>
    );
});

export default NewSessionTaskModal;